import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";

const Categories = ({ categories, visible, onClick, onBackClick }) => {
    const [filter, setFilter] = useState("");
    const [filteredCategories, setFilteredCategories] = useState(categories);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    useEffect(() => {
        if (filter && hasElements(categories)) {
            setFilteredCategories(categories.filter((category) => category.toLowerCase().includes(filter.toLowerCase())));
        } else {
            setFilteredCategories(categories);
        }

        return () => {
            setFilteredCategories(categories);
        };
    }, [filter, categories]);

    return (
        <div
            className={clsx("layout categories-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>Category</h3>
                    <small>
                        <i>Select a category to view forms</i>
                    </small>
                    <TextField type="text" placeholder="Search..." value={filter} onChange={onFilterChange} />
                    <div className="categories">
                        {filteredCategories.map((category) => (
                            <Card key={category} onClick={() => onClick(category)}>
                                <span>{category}</span>
                                <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                            </Card>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.array,
    visible: PropTypes.bool,
    onClick: PropTypes.func,
    onBackClick: PropTypes.func,
};

Categories.defaultProps = {
    categories: [],
    visible: true,
    onClick: () => {},
    onBackClick: () => {},
};

export default Categories;
